import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const Terms = () => {
  return (
    <div className="container mt-4">
    <h2 className="text-center mb-4">User Terms and Conditions</h2>
    
    <div className="accordion" id="userTermsAccordion">
      <div className="accordion-item">
        <h2 className="accordion-header" id="headingOne">
          <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
            Can a User be suspended or terminated?
          </button>
        </h2>
        <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#userTermsAccordion">
          <div className="accordion-body">
            <p>The Company reserves the right to suspend or terminate the access to Services (or any part thereof)...</p>
            <ul>
              <li>If any information provided is inaccurate, not current, or incomplete.</li>
              <li>If the User engages in unlawful, fraudulent, or negligent actions.</li>
              <li>If the User fails to comply with any agreement or applicable law.</li>
              <li>If the User is non-compliant with these Terms.</li>
            </ul>
            <p>If violations lead to criminal or civil actions, the Company may pursue such actions at its discretion.</p>
          </div>
        </div>
      </div>

      <div className="accordion-item">
        <h2 className="accordion-header" id="headingTwo">
          <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
            User Obligations
          </button>
        </h2>
        <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#userTermsAccordion">
          <div className="accordion-body">
            <p>Users must comply with the following obligations:</p>
            <ul>
              <li>Access to Services does not grant ownership of Valmo’s website or tools.</li>
              <li>All content is protected under applicable laws and is owned by the Company.</li>
              <li>Users may not modify, publish, transmit, sell, or exploit content commercially.</li>
              <li>Users must not engage in defamation, abuse, harassment, or unlawful activities.</li>
              <li>Users must not access accounts or impersonate others.</li>
              <li>Compliance with IT Act 2000 and applicable international laws is required.</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="accordion-item">
        <h2 className="accordion-header" id="headingThree">
          <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
            GST Registration Requirement
          </button>
        </h2>
        <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#userTermsAccordion">
          <div className="accordion-body">
            <p>Users are responsible for complying with GST and other tax laws. The Company is not liable for any non-compliance.</p>
            <p>Users should seek independent tax advice regarding their business transactions.</p>
          </div>
        </div>
      </div>

      <div className="accordion-item">
        <h2 className="accordion-header" id="headingFour">
          <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
            Accuracy and Completeness of Information
          </button>
        </h2>
        <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#userTermsAccordion">
          <div className="accordion-body">
            <p>The Company strives to keep information accurate but does not guarantee completeness, accuracy, or timeliness.</p>
            <p>Information is provided for general reference and should not be solely relied upon for decisions.</p>
            <p>The Company reserves the right to modify content at any time without obligation to update information.</p>
          </div>
        </div>
      </div>

      <div className="accordion-item">
        <h2 className="accordion-header" id="headingFive">
          <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
            Collection and Use of User Information
          </button>
        </h2>
        <div id="collapseFive" className="accordion-collapse collapse" aria-labelledby="headingFive" data-bs-parent="#userTermsAccordion">
          <div className="accordion-body">
            <p>The Company collects both personal and non-personal information to facilitate services.</p>
            <p>Users are encouraged to review Valmo’s Privacy Policy for details on data collection and processing.</p>
          </div>
        </div>
      </div>

      <div className="accordion-item">
        <h2 className="accordion-header" id="headingSix">
          <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
            Third-Party Links and Content
          </button>
        </h2>
        <div id="collapseSix" className="accordion-collapse collapse" aria-labelledby="headingSix" data-bs-parent="#userTermsAccordion">
          <div className="accordion-body">
            <p>Our website may include third-party content and links, but we do not guarantee their accuracy or security.</p>
            <p>Users should review third-party policies before engaging in transactions.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  );
};

export default Terms;